export default __webpack_public_path__ + "static/arindamLehri6-6e10d53b7721ad9f960fa3aa138b5960.jpg";